import jqRequest from '../jqRequest'
import qsUrls from '../urls/questionnaire'

export default {
  // 获取问卷详情
  getQuestionnaireDetail(data){
    return jqRequest.request(qsUrls.getQuestionnaireDetail, data);
  },
  // 获取问卷详情 H5
  getQuestionnaireDetailForH5(data){
    return jqRequest.request(qsUrls.getQuestionnaireDetailForH5, data);
  },
  // 获取多主体
  getMainbodyList(data){
    return jqRequest.request(qsUrls.getMainbodyList, data);
  },
  // 获取调查问卷需要显示的自定义字段
  getCustomMemberFields(data){
    return jqRequest.request(qsUrls.getCustomMemberFields, data);
  },
  // 获取问卷题目
  getQuestionnaireSubjects(data) {
    return jqRequest.request(qsUrls.getQuestionnaireSubjects, data);
  },
  // 保存答卷
  addQuestionAnswer(data) {
    return jqRequest.request(qsUrls.addQuestionAnswer, data);
  },
}